import { RouteObject, redirect } from 'react-router-dom';
import { routeAccount } from './app/components/account/account.route';
import { routeEditCommPreferences } from './app/components/account/components/edit-comm-preferences/edit-comm-preferences.route';
import { routeEditMembership } from './app/components/account/components/edit-membership/edit-membership.route';
import { routeEditPersonalInfo } from './app/components/account/components/edit-personal-info/edit-personal-info.route';
import { routeActionPlan } from './app/components/action-plan/action-plan.route';
import { routeBuildActionPlan } from './app/components/action-plan/components/build-action-plan/build-action-plan.route';
import { routeDashboard } from './app/components/dashboard/dashboard.route';
import { routeEarlyAccess } from './app/components/early-access/early-access.route';
import { routeLoadingScreen } from './app/components/loading-screen/loading-screen.route';
import { routePayment } from './app/components/payment/payment.route';
import {
  routePpra,
  routePpraMembershipInterstitial,
  routePpraPayment,
  routePpraQuestionnaire,
  routePpraResults,
  routePpraResultsLoading,
  routePpraResultsPdp,
} from './app/components/ppra/ppra.route';
import { routeQuestionnaire } from './app/components/questionnaire/questionnaire.route';
import { routeRiskAnalysis } from './app/components/risks/risk-analysis/risk-analysis.route';
import { routeRiskTrend } from './app/components/risks/risk-trend/risk-trend.route';
import { routeSingleCancerView } from './app/components/risks/single-cancer-view/single-cancer-view.route';
import { routeSignIn } from './app/components/sign-in/sign-in.route';
import { routeSignUp } from './app/components/sign-up/sign-up.route';
import { routeTestDetails } from './app/components/testing-plan/components/test-details/test-details.route';
import { routeTestingPlanComplete } from './app/components/testing-plan/components/your-testing-plan/components/complete-test/complete-test.route';
import { routeTestingPlan } from './app/components/testing-plan/testing-plan.route';
import Layout from './components/layout-auth/layout-auth'; // actually not used for authenticated routes, so that's cool
import MainLayout from './components/main-layout/main-layout'; // this is what is used for authenticated routes
import { ROUTE_SIGN_IN } from './constants/routes';
import authService from './services/auth.service';
import { routeQuizlet, routeQuizletQuestionnaire, routeQuizletResults } from './app/components/quizlet/quizlet.route';

const router: Array<RouteObject> = [
  {
    loader() {
      if (!authService.isLoggedIn()) {
        // This doesn't check for "isLoggedIn", it only checks for the access token in local storage
        // It doesn't matter if it's valid or not, so that's also cool
        return redirect(ROUTE_SIGN_IN);
      }
      return null;
    },
    children: [
      {
        Component: MainLayout,
        children: [
          routeAccount,
          routeEditPersonalInfo,
          routeActionPlan,
          routeQuestionnaire,
          routeTestingPlan,
          routeTestDetails,
          routeTestingPlanComplete,
          routeDashboard,
          routeBuildActionPlan,
          routeEditMembership,
          routeRiskAnalysis,
          routeRiskTrend,
          routeSingleCancerView,
          routeEditCommPreferences,
          routeLoadingScreen,
        ],
      },
    ],
  },
  {
    Component: Layout,
    children: [
      routeSignUp,
      routeEarlyAccess,
      routeSignIn,
      routePayment,
      routePpra,
      routePpraPayment,
      routePpraQuestionnaire,
      routePpraResults,
      routePpraResultsLoading,
      routePpraResultsPdp,
      routePpraMembershipInterstitial,
      routeQuizlet,
      routeQuizletQuestionnaire,
      routeQuizletResults,
    ],
  },
];

export default router;
